// extracted by mini-css-extract-plugin
module.exports = {"clickable":"NavigationChip_clickable__qnraT"};